var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contontaa"},[_c('div',{ref:"myChart",style:({ width: '8rem', height: '8rem' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }